import { parseDay } from "../lib/datetime";
import { getSystemLocale } from "../lib/locale/locale";

export function displayBookingDate(
  startDate: string,
  endDate?: string,
  month: "long" | "short" = "long"
): string {
  const dateOptions = {
    month: month,
    day: "numeric",
    year: "numeric",
  } as const;

  if (startDate === endDate || !endDate) {
    return parseDay(startDate).toLocaleDateString(
      getSystemLocale(),
      dateOptions
    );
  }

  return `${parseDay(startDate).toLocaleDateString(
    getSystemLocale(),
    dateOptions
  )} - ${parseDay(endDate).toLocaleDateString(getSystemLocale(), dateOptions)}`;
}
